import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SharedHomeProvider } from './Home/context/SharedHomeContext'

export const SupplierReconciliation = () => {
  const location = useLocation()

  // Only wrap with SharedHomeProvider for launchpad and management routes
  const isHomeRoute = location.pathname.includes('/launchpad') || location.pathname.includes('/management')

  if (isHomeRoute) {
    return (
      <SharedHomeProvider>
        <Outlet />
      </SharedHomeProvider>
    )
  }

  return <Outlet />
}
